(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["care-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCareGuide(root) {
      if (!root || root.dataset.careInit === 'true') return;

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-care-panel]'));
      if (tabs.length === 0 || panels.length === 0) return;

      root.classList.add('care-guide--js');
      root.dataset.careInit = 'true';

      // Block settings aren't readable from the section's block loop, so each
      // panel carries its tab label as data-tab-label; copy it onto the tab.
      tabs.forEach(function (tab, i) {
        var panel = panels[i];
        var label = panel && panel.getAttribute('data-tab-label');
        if (label) tab.textContent = label;
      });

      function activate(index, moveFocus) {
        tabs.forEach(function (tab, i) {
          var selected = i === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          if (selected && moveFocus) tab.focus();
        });
        panels.forEach(function (panel, i) {
          panel.classList.toggle('is-active', i === index);
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          activate(i, false);
        });
        tab.addEventListener('keydown', function (event) {
          var last = tabs.length - 1;
          var next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            next = i === last ? 0 : i + 1;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            next = i === 0 ? last : i - 1;
          } else if (event.key === 'Home') {
            next = 0;
          } else if (event.key === 'End') {
            next = last;
          }
          if (next !== null) {
            event.preventDefault();
            activate(next, true);
          }
        });
      });

      var initial = 0;
      tabs.forEach(function (tab, i) {
        if (tab.getAttribute('aria-selected') === 'true') initial = i;
      });
      activate(initial, false);
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-care-guide]');
      Array.prototype.forEach.call(roots, initCareGuide);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
